import React from "react";
import cx from "clsx";
import Button from "../../../Button";
const AccordionSectionHeader = ({
  children,
  actions,
  expanded,
  onExpand,
  expandable,
  dataTest
}) => /*#__PURE__*/React.createElement("div", {
  className: cx("p-600 bg-white-normal flex items-center", expanded ? "min-h-[19px]" : "min-h-[44px]"),
  "data-test": dataTest && `${dataTest}Header`
}, /*#__PURE__*/React.createElement("div", {
  className: "flex grow items-center"
}, children), !expanded && /*#__PURE__*/React.createElement("div", {
  className: "ms-600 flex"
}, expandable && (actions || /*#__PURE__*/React.createElement(Button, {
  onClick: onExpand,
  type: "secondary"
}, "Open"))));
export default AccordionSectionHeader;